import React, { useEffect, useState, useRef } from "react";

import moment from "moment";

import { useUser, useLang } from "../zustand/store.js";

import { toast } from 'react-toastify';

import routes from "../libs/routes";
import images from "../libs/images";
import consts from "../libs/consts";

import { emailMasking, regPhone, regEmail, regPassword, regNick, errorMessage } from "../utils/utils";
import * as APIS from "../utils/service";

import Image from '../components/Image';
import InputFile from '../components/InputFile';
import Input from '../components/Input';
import Button from '../components/Button';

import { LangText } from "../zustand/dict.js";

// import { lang } from '../utils/utils';

export default function Menu10() {

    const ref = useRef(null);
    const hpref = useRef();
    const emailref = useRef();
    const pwref = useRef();
    const repwref = useRef();
    const nickref = useRef();

    const { user, reload } = useUser();
    const { country, getLang } = useLang();

    const [ pw, setpw ] = useState('');
    const [ repw, setrepw ] = useState('');
    const [ nickname, setnickname ] = useState('');
    const [ profile, setprofile ] = useState('');

    const [ error, setError ] = useState({});

    const [ load, setLoad ] = useState(false);

    useEffect(() => {

        setnickname(user?.name);
        setprofile(user?.profile);

    }, [user]);

    const handleKeyDown = (e) => {
        if (e?.key === 'Enter') {
            submitFunc();
        }
    };

    const submitFunc = () => {

        if(load) return;

        if(!regNick.test(nickname)) {
            setError({...error, signNick: <LangText id={'error_reg_nickname'}/>})
            nickref?.current?.focus();
            return;
        }

        if(pw || repw) {
            if(!regPassword.test(pw)) {
                setError({...error, signPw: <LangText id={'error_reg_pass'}/>})
                pwref?.current?.focus();
                return;
            }
    
        }
        
        setLoad(true);

        let sender = {
            profile: profile === 'delete' || profile?.base ? profile : null,
            name: user?.name !== nickname ? nickname : null,
            pass1: pw ? pw : null,
            pass2: repw ? repw : null,
        }

        console.log('sender', sender);

        APIS.post('/user/edit', sender).then(( { data } ) => {
            console.log('data', data);

            toast.success(<LangText id={'success_change_data'}/>);
            setpw('');
            setrepw('');
            reload();

        }).catch(({ response }) => {
            
            if(response?.data?.code === 1006) {
                setError({...error, signNick: <LangText id={response?.data?.msgkey}/>})
                nickref?.current?.focus();
            } else {
                errorMessage(response?.data);
            }
            
        }).finally(() => {
            setLoad(false);
        });
       

    }

    return (
        <>
            <div className="content">
                <div className="profile_setting_box">
                    <p className={['logo']}/>
                    <p className="title"><LangText id={'text_user_setting'} /></p>

                    <div className="profile_image_box">
                        <InputFile 
                            type="file" 
                            title={<LangText id={'btn_upload_profile'} />}
                            deleteTitle={<LangText id={'btn_delete_profile'}/>}
                            placeholder="입력해주세요." 
                            name="profile_image" 
                            value={profile} 
                            setValue={setprofile} 
                            defaultFileName={user?.profile ? consts.imgUrl + user?.profile : null}
                            valid="image" 
                            onDelete={() => setprofile('delete')}
                        />
                    </div>
                    <div className='find_form'>
                        <Input 
                            refs={nickref}
                            name="signNick" 
                            placeholder={getLang({key: 'placeholder_nickname'})}
                            value={nickname} 
                            setValue={setnickname} 
                            onKeyDown={handleKeyDown} 
                            label={<LangText id={'text_nickname'}/>} 
                            error={error} 
                            setError={setError}
                        />
                        <div className='new_pw_box'>
                            <Input 
                                type="password"
                                name="signPw" 
                                placeholder={getLang({key: 'placeholder_pass'})}
                                value={pw} 
                                setValue={setpw} 
                                onKeyDown={handleKeyDown} 
                                label={<LangText id={'text_pass'}/>} 
                                error={error} 
                                setError={setError}
                            />
                            <Input 
                                type="password"
                                name="signRePw" 
                                placeholder={getLang({key: 'placeholder_pass_re'})}
                                value={repw} 
                                setValue={setrepw} 
                                onKeyDown={handleKeyDown} 
                                error={error} 
                                setError={setError}
                            />
                        </div>
                    </div>

                    <Button title={<LangText id={'btn_change'}/>} onClick={submitFunc}/>
                </div>
            </div>
        </>
    );
}
